module App.Classes {
    export interface ILicensePlateInformation {
        brand: string
        type: string
        constructionYear: number
        fuelType: string
        kw: number
        cilinderCapacity: number
        found: boolean
        isVwEconomy: boolean
        newWebColor: Interfaces.IWebsiteColor
        isVolvo: boolean
        customCarDescription: string
        nextApkDate: Date
        apkIsValid: boolean
        licensePlate: string
    }

    export class LicensePlateInformation implements ILicensePlateInformation {
        customCarDescription: string
        brand: string
        type: string
        constructionYear: number
        fuelType: string
        kw: number
        cilinderCapacity: number
        found: boolean
        isVwEconomy: boolean
        newWebColor: Interfaces.IWebsiteColor
        isVolvo: boolean
        nextApkDate: Date
        apkIsValid: boolean
        licensePlate: string
    }
}